import { render, staticRenderFns } from "./AttributeChange.vue?vue&type=template&id=708c57ac&scoped=true&"
import script from "./AttributeChange.vue?vue&type=script&lang=js&"
export * from "./AttributeChange.vue?vue&type=script&lang=js&"
import style0 from "./AttributeChange.vue?vue&type=style&index=0&id=708c57ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c57ac",
  null
  
)

export default component.exports